__turbopack_context__.v({
  "preFooterBanner": "PreFooterBanner-module__PVk28W__preFooterBanner",
  "textContent": "PreFooterBanner-module__PVk28W__textContent",
});
